import { http } from '@/core/api/';

const baseURL = 'api/code';

export default {
  async getLocationTypes(codeView) {
    const { status, data } = await http.get(
      `${baseURL}/locationtypes/${codeView}`
    );
    if (status != 200) return [];
    return data;
  },
  async getAvailableMonthsByAcademicYear(academicYearId) {
    const { status, data } = await http.get(
      `${baseURL}/availablemonths/${academicYearId}`
    );
    if (status != 200) return [];
    return data;
  },
  /**
   * Get discipline's types
   * params: {
   *            serviceTypeIds: array of ids,
   *            categories: array of categories (Flags such as ValidForPEI=1 / validForAppointment=5,etc.., )
   *            disciplineIds: array of discipline ids to be included (not matter if they do not match with the categories)
   *            module: array of application module (default null),
   *            model: object (endpoint DTO)
   * },
   */
  async getDisciplineByTypes(params) {
    let url = `${baseURL}/getdisciplinebytype?`;

    params = params || {};
    params.serviceTypeIds = params.serviceTypeIds || [];

    params.serviceTypeIds.forEach((serviceTypeId) => {
      url += `&serviceTypeIds=${serviceTypeId}`;
    });
    url = url.replace('?&', '?');
    const { status, data: response } = await http.get(url);
    return status !== 200 ? [] : response;
  },
  async getDisciplineTypes(params) {
    let url = `${baseURL}/disciplinetypes?`;

    params = params || {};
    params.serviceTypeIds = params.serviceTypeIds || [];
    params.categories = params.categories || [];
    params.disciplineIds = params.disciplineIds || [];
    params.modules = params.modules || [];

    params.serviceTypeIds.forEach((serviceTypeId) => {
      url += `&serviceTypeIds=${serviceTypeId}`;
    });

    params.categories.forEach((categoryId) => {
      url += `&categories=${categoryId}`;
    });

    params.disciplineIds.forEach((disciplineId) => {
      url += `&disciplineIds=${disciplineId}`;
    });

    params.modules.forEach((moduleId) => {
      url += `&modules=${moduleId}`;
    });

    url = url.replace('?&', '?');

    const { status, data: response } = await http.get(url);
    return status !== 200 ? [] : response;
  },
  getFrequencyType() {
    return http.get(`${baseURL}/frequencytype`);
  },
  /**
   *
   * @param {
   * DisciplineTypeId,
   * ValidForRemedioProvisionalFlag,
   * ValidForPEIFlag,
   * ValidForEFAFlag,
   * ValidForEducationServiceFlag,
   * ValidForTherapyAndOtherServicesFlag,
   * Screen
   * } payload
   * @returns
   */
  getServiceModalities(payload) {
    if (payload !== undefined) {
      return http.get(`${baseURL}/servicemodalities`, {
        params: payload,
      });
    }
    return http.get(`${baseURL}/servicemodalities`);
  },
  getTherapyDurations() {
    return http.get(`${baseURL}/therapydurations`);
  },
  getMaterialCategoryTypes() {
    return http.get(`${baseURL}/me/category`);
  },
  getMaterialItemTypes(saloonId, categoryId) {
    return http.get(`${baseURL}/me/${saloonId}/${categoryId}`);
  },
  getMaterialsequipmentRequisitionTypes() {
    return http.get(`${baseURL}/me/requisitiontypes`);
  },
  getMaterialsequipmentRequisitionStatus() {
    return http.get(`${baseURL}/me/requisitionstatus`);
  },
  getStudentReevaluationPeriods() {
    return http.get(`${baseURL}/studentreevaluationperiods`);
  },
  getReevaluationTimes() {
    return http.get(`${baseURL}/reevaluationtimes`);
  },
  async getGrades(params) {
    let url = `${baseURL}/grades?`;

    params = params || {};
    params.ids = params.ids || [];

    params.ids.forEach((id) => {
      url += `&exclude=${id}`;
    });
    url = url.replace('?&', '?');
    const { status, data: response } = await http.get(url);
    return status !== 200 ? [] : response;
  },
};

export const getPurchaseOrders = () => http.get(`${baseURL}/purchaseorders`);

export const getApplications = () => http.get(`${baseURL}/application`);

export const getModules = (applicationId) =>
  http.get(`${baseURL}/modules/${applicationId}`);

export const getLinks = (moduleId) => http.get(`${baseURL}/links/${moduleId}`);

export const getEvaluationSourceTypes = () =>
  http.get(`${baseURL}/getevaluationsourcetypes`);

export const getEvaluationTypes = () =>
  http.get(`${baseURL}/getevaluationtypes`);

export const getCodeDisciplineTypes = (serviceTypeId, validForFlag) =>
  http.get(`${baseURL}/getcodedisciplinetypes`, {
    params: { serviceTypeId, validForFlag },
  });

export const getStudentEquipments = () =>
  http.get(`${baseURL}/studentEquipments`);

export const getEvaluationDiscussionStatus = () =>
  http.get(`${baseURL}/evaluationdiscussionstatus`);

export const getRejectionReasons = () =>
  http.get(`${baseURL}/evaluationrejectiontypes`);

export const getRejectionReasonsV2 = () =>
  http.get(`${baseURL}/v2/evaluationrejectiontypes`);

export const getStudentReferralPhases = () =>
  http.get(`${baseURL}/studentReferralPhases`);

export const getEvaluationDiscussionDocumentTypes = () =>
  http.get(`${baseURL}/evaluationdiscussiondocumenttypes`);

export const getAnalysisDocumentTypes = () =>
  http.get(`${baseURL}/getdocumentanalysistype`);

export const getEFADocumentTypes = () =>
  http.get(`${baseURL}/efa/documenttypes`);

export const getAlternatePlacements = (studentAge) =>
  http.get(`${baseURL}/alternateplacementsbyage/${studentAge}`);

export const getAlternatePlacementList = () =>
  http.get(`${baseURL}/alternateplacementes`);

export const getStudentVisualImpairmentStatuses = () =>
  http.get(`${baseURL}/student/visualimpairments/statuses`);

export const getLanguagesValidForREIV = () =>
  http.get(`${baseURL}/languages/validforREIV`);

export const getTransitionStudentActivities = () =>
  http.get(`${baseURL}/transitionstudentactivities`);
export const getTransitionStatuses = () =>
  http.get(`${baseURL}/gettransitionstatuses`);

export const getPeriods = () => http.get(`${baseURL}/periods`);

export const getPrimaryStudentLanguages = () =>
  http.get(`${baseURL}/primarystudentlanguages`);
export const getCodeStudentDiagnostics = async (disciplineTypeId) => {
  return await http.get(`${baseURL}/studentdiagnostics/${disciplineTypeId}`);
};
